export { CONTRACT_ADDRESS, crossbell, crossbellTestnet, getJsonRpcAddress, isCrossbellChain, isCrossbellMainnet, isCrossbellTestnet, setJsonRpcAddress } from '../chunk-Z5ML27IN.mjs';
import '../chunk-FHBV65QG.mjs';
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map